import { Circle } from '@dealstack/frontend/shared/components/common/Circle';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { ConfirmationModalV3 } from '@dealstack/frontend/shared/components/ConfirmationModal/ConfirmationModalV3';
import { investmentJoinAndAllocationContext } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/InvestmentJoinAndAllocation';
import { Divider, Flex, Text, Title, Button } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	className?: string;
}

const JoinAndAllocationCompletedStep = ({ className }: Props) => {
	const tInvestor = useTranslationInvestor();
	const { setIsContinueDisabled } = useContext(investmentJoinAndAllocationContext);

	const [showModal, setShowModal] = useState(true);

	useEffect(() => {
		setIsContinueDisabled(false);
	}, []);

	return (
		<div className={className}>
			<Flex
				direction="column"
				gap="2rem"
				bg="blue.0"
				sx={{
					marginTop: '2rem',
					padding: '2rem',
					borderRadius: '4px',
					position: 'relative',
				}}
			>
				<Flex align="baseline" gap="0.5rem">
					<Circle variant="filled">
						<Text fz="lg" fw={600} lh="1.43rem" c="gray.0">
							1
						</Text>
					</Circle>
					<Flex direction="column" gap="0.5rem">
						<Title order={5}>
							{tInvestor('investment.join.completed.step_1.title')}
						</Title>
						<Text sx={{ maxWidth: '40rem' }}>
							{tInvestor('investment.join.completed.step_1.subtitle')}
						</Text>
					</Flex>
				</Flex>

				<Divider />

				<Flex align="baseline" gap="0.5rem">
					<Circle variant="filled">
						<Text fz="lg" fw={600} lh="1.43rem" c="gray.0">
							2
						</Text>
					</Circle>
					<Flex direction="column" gap="0.5rem">
						<Title order={5}>
							{tInvestor('investment.join.completed.step_2.title')}
						</Title>
						<Text sx={{ maxWidth: '40rem' }}>
							{tInvestor('investment.join.completed.step_2.subtitle')}
						</Text>
					</Flex>
				</Flex>

				<Divider />

				<Flex align="baseline" gap="0.5rem">
					<Circle variant="filled">
						<Text fz="lg" fw={600} lh="1.43rem" c="gray.0">
							3
						</Text>
					</Circle>
					<Flex direction="column" gap="0.5rem">
						<Title order={5}>
							{tInvestor('investment.join.completed.step_3.title')}
						</Title>
						<Text sx={{ maxWidth: '40rem' }}>
							{tInvestor('investment.join.completed.step_3.subtitle')}
						</Text>
					</Flex>
				</Flex>
			</Flex>

			{showModal && (
				<ConfirmationModalV3
					title={tInvestor('investment.continue_confirm_modal.title')}
					description={tInvestor('investment.continue_confirm_modal.subtitle')}
					children={
						<Flex>
							<Button
								size="md"
								variant="secondary"
								onClick={() => setShowModal(false)}
								data-testid={
									TEST_ELEMENT_IDS.MIP_MANAGE_SEND_INVITATION_MODAL_CONFIRM
								}
							>
								{tInvestor('investment.join.completed.modal.understood')}
							</Button>
						</Flex>
					}
				/>
			)}
		</div>
	);
};

const Styled = styled(JoinAndAllocationCompletedStep)`
	max-width: 65rem;
	${Circle} {
		--size: 2rem;
	}
`;

export { Styled as JoinAndAllocationCompletedStep };
